import pluralize from 'pluralize';

export default {
    install(app) {
        // Provide the pluralize function to be used in components
        app.provide('$pluralize', pluralize);

        // Add global property to be used in any component
        app.config.globalProperties.$pluralize = pluralize;

        // Note: Filters have been removed in Vue 3.
        app.config.globalProperties.$filterPluralize = (...args) => pluralize(...args);
    },
};
